import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-circle-number',
    templateUrl: './circle-number-substep.component.html',
    styleUrls: ['./circle-number-substep.component.less'],
    imports: [CommonModule]
})
export class CircleNumberSubstepComponent {

  @Input() stepNumber: string;
  @Input() isSubstep: boolean;
}
